import { Row } from '@tanstack/react-table';

import { PayrunListItem } from '@xemplo/gp-types';
import { TooltipPlacement } from '@xemplo/tooltip';

import * as S from '../payrun-base-table.styles';

/**
 * The precise status within the milestone bucket — the Milestone badge collapses several
 * distinct statuses into one step, so this cell is what distinguishes e.g. Processed from
 * Completed. Renders the BE's `payrunStatusName` verbatim.
 */
export const PayrunStatusCell = (props: Row<PayrunListItem>) => {
  const status = props.original.payrunStatusName || '-';

  return (
    <S.InlineTooltip text={status} placement={TooltipPlacement.Top}>
      <S.TrunctatedText>{status}</S.TrunctatedText>
    </S.InlineTooltip>
  );
};
